import { render } from "./successResultPage.vue?vue&type=template&id=9cc2979a&scoped=true"
import script from "./successResultPage.vue?vue&type=script&lang=js"
export * from "./successResultPage.vue?vue&type=script&lang=js"

import "./successResultPage.vue?vue&type=style&index=0&id=9cc2979a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc2979a"]])

export default __exports__